import * as $ from "jquery";
import { API_BASE_URL } from "../config";
import { getAccessToken as getTokenFromAuth } from "./auth-helper";

export interface AudienceGroup {
  id: string;
  displayName: string;
  groupType: string;
}

export interface AudienceUser {
  id: string;
  displayName: string;
  mail?: string | null;
  userPrincipalName?: string | null;
}

export interface DirectoryPage<T> {
  items: T[];
  nextPageToken?: string | null;
  totalCount?: number | null;
}

function token(): string {
  const value = getTokenFromAuth();
  if (!value) throw new Error("not_authenticated");
  return value;
}

export function searchAudienceGroups(query: string, pageToken?: string | null): Promise<DirectoryPage<AudienceGroup>> {
  const params = new URLSearchParams();
  if (query) params.set("q", query);
  if (pageToken) params.set("pageToken", pageToken);
  return $.ajax({
    type: "GET",
    url: `${API_BASE_URL}/api/audience/groups/search?${params.toString()}`,
    headers: { Authorization: `Bearer ${token()}` },
    cache: false,
  });
}

export function getAudienceGroupsByIds(ids: string[]): Promise<AudienceGroup[]> {
  return $.ajax({
    type: "GET",
    url: `${API_BASE_URL}/api/audience/groups/by-ids?ids=${encodeURIComponent(ids.join(","))}`,
    headers: { Authorization: `Bearer ${token()}` },
    cache: false,
  });
}

export function getAudienceUsers(
  groupIds: string[],
  query: string,
  pageToken?: string | null,
  take = 50
): Promise<DirectoryPage<AudienceUser>> {
  return $.ajax({
    type: "POST",
    url: `${API_BASE_URL}/api/audience/users`,
    contentType: "application/json",
    headers: { Authorization: `Bearer ${token()}` },
    data: JSON.stringify({ groupIds, query, pageToken, take }),
    cache: false,
  });
}
